import { FaClock } from "@react-icons/all-files/fa/FaClock";
import React from "react";
// import Button from "../../components/Button";
import styles from "./styles/GameButton.module.css";
import { useLobby, showCustomPopup } from "../../ducks/lobby";
import { formatTime } from "../../util/util";
import Loader from "../../components/Loader";
import { saveAndChooseGame } from "../shared/saveAndChooseGame";
import { VARIANT_CHESS960 } from "@chesshotel/constants";
import { FaDiceSix } from "@react-icons/all-files/fa/FaDiceSix";

export const BUTTON_TYPE_CUSTOM = 1;

export default function GameButton({
  type = null,
  time,
  inc,
  timeType,
  variant,
}) {
  const lobby = useLobby();
  const chosenTime = lobby.time;
  const chosenInc = lobby.inc;
  const chosenVariant = lobby.variant;
  const gamesCreated = lobby.gamesCreated;

  let isSentGame = false;
  gamesCreated.forEach((game) => {
    if (time === game.time && inc === game.inc && variant === game.variant) {
      isSentGame = true;
    }
  });

  const isChosenGame =
    time === chosenTime && inc === chosenInc && variant === chosenVariant;
  const spinner = isSentGame && (
    <div className="absolute right-0.5 top-0.5 z-10">
      <Loader color="blue" />
    </div>
  );

  return (
    <button
      color="white"
      className={`relative flex flex-col flex-1 items-center justify-center 
         rounded h-16 shadow-custom m-2 text-altblue-500
         ${
           isChosenGame
             ? "bg-blue-100 border-2 border-altblue-500 mx-7px"
             : "bg-altgray-50 border border-altgray-300 hover:opacity-70"
         }
         `}
      onClick={() => {
        saveAndChooseGame(time, inc, variant);
        if (type === BUTTON_TYPE_CUSTOM) {
          showCustomPopup(true);
        }
      }}
    >
      {spinner}
      <div className={time ? styles.timeType : styles.customType}>
        {timeType}
      </div>
      {time && (
        <div className="flex items-center space-x-0.5 text-xs md:text-sm">
          <FaClock />
          <div className="font-normal">{formatTime(time, inc)}</div>
          {BUTTON_TYPE_CUSTOM === type && (
            <div className="pl-1">
              {variant === VARIANT_CHESS960 && <FaDiceSix />}
            </div>
          )}
        </div>
      )}
    </button>
  );
}
